<template>
  <div>
    <b-modal
      v-model="visivel"
      title="📄 Templates disponíveis"
      hide-footer
      size="lg"
      centered
      body-class="p-3"
    >
      <p class="text-muted small mb-4 text-center">
        Clique em um template abaixo para enviá-lo ao cliente.
      </p>

      <b-row>
        <b-col
          v-for="template in templates"
          :key="template.name"
          cols="12"
          md="4"
          class="mb-3"
        >
          <div
            class="template-card p-3 rounded shadow-sm h-100 d-flex flex-column justify-content-between"
            :class="{
              'template-card-confirmed': templateSelecionado === template.name && statusEnvio === 200,
              'template-card-erro': templateSelecionado === template.name && statusEnvio !== null && statusEnvio !== 200
            }"
            @click="abrirConfirmacao(template)"
          >
            <div>
              <div class="d-flex align-items-center justify-content-between mb-2">
                <strong>{{ template.name }}</strong>
                <i class="feather icon-message-square text-primary" />
              </div>
              <div class="template-body-preview small text-muted">
                {{ limitarTexto(getBody(template) || 'Sem conteúdo') }}
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-modal>

    <!-- Modal de confirmação personalizado -->
    <b-modal
      id="confirmacao-envio-template"
      v-model="modalConfirmacaoVisivel"
      title="Confirmar envio do template"
      hide-footer
      centered
    >

      <p class="text-center">
        <h5>Enviar o template {{ getHeader(templateSelecionadoObj) }}?</h5>
      </p>

      <div class="preview-template p-3 rounded">
        <!-- <div v-if="getHeader(templateSelecionadoObj)" class="mb-2 font-weight-bold">
            {{ getHeader(templateSelecionadoObj) }}
          </div> -->
        <div>{{ getBody(templateSelecionadoObj) }}</div>
        <!-- <div v-if="getFooter(templateSelecionadoObj)" class="mt-2 text-muted small">
            {{ getFooter(templateSelecionadoObj) }}
          </div> -->
      </div>

      <div class="d-flex justify-content-end mt-4">
        <b-button
          variant="outline-secondary"
          @click="modalConfirmacaoVisivel = false"
        >
          Cancelar
        </b-button>
        <b-button
          variant="primary"
          class="ml-2"
          @click="enviar(templateSelecionadoObj)"
        >
          Enviar
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: 'ModalTemplates',
  props: {
    templates: Array,
    value: Boolean,
    enviarTemplate: Function, // função recebida do pai
  },
  data() {
    return {
      templateSelecionado: null,
      templateSelecionadoObj: {},
      modalConfirmacaoVisivel: false,
      statusEnvio: null,
    }
  },
  computed: {
    visivel: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
  },
  methods: {
    abrirConfirmacao(template) {
      this.templateSelecionado = template.name
      this.templateSelecionadoObj = template
      this.modalConfirmacaoVisivel = true
    },
    getComponent(template, type) {
      const comp = template.components?.find(c => c.type === type)
      return comp?.text || null
    },
    getBody(template) {
      return this.getComponent(template, 'BODY')
    },
    getHeader(template) {
      return this.getComponent(template, 'HEADER')
    },
    getFooter(template) {
      return this.getComponent(template, 'FOOTER')
    },
    limitarTexto(texto, limite = 120) {
      return texto.length > limite ? `${texto.substring(0, limite)}...` : texto
    },
    async enviar(template) {
      this.statusEnvio = null

      try {
        const response = await this.enviarTemplate(template.name, this.getComponent(template, 'BODY'))
        this.statusEnvio = response.status

        if (response.status === 200) {
          // Sucesso
          this.modalConfirmacaoVisivel = false
          setTimeout(() => {
            this.templateSelecionado = null
            this.statusEnvio = null
            this.visivel = false
          }, 1000)
        } else {
          this.modalConfirmacaoVisivel = false
          this.$bvToast.toast(
            `Erro ao enviar template: ${
                 response.data?.message || response.statusText}`,
            {
              title: 'Erro',
              variant: 'danger',
              solid: true,
            },
          )
        }
      } catch (e) {
        this.statusEnvio = 500
        this.modalConfirmacaoVisivel = false
        this.$bvToast.toast('Erro inesperado ao enviar o template.', {
          title: 'Erro',
          variant: 'danger',
          solid: true,
        })
      }
    },
  },
}
</script>

  <style scoped>
  .template-card {
    cursor: pointer;
    background-color: #f9f9fb;
    transition: all 0.2s ease;
    border: 1px solid #e0e0e0;
  }
  .template-card:hover {
    background-color: #eef3ff;
    border-color: #c6d4ff;
  }
  .template-card-confirmed {
    background-color: #d1ecf1 !important;
    border-color: #6fb9df !important;
  }
  .template-card-erro {
    background-color: #f8d7da !important;
    border-color: #f5c6cb !important;
  }
  .template-body-preview {
    font-style: italic;
    color: #666;
  }
  .preview-template {
    background-color: #f5f0fb;
    color: #4c2a85;
    font-size: 0.95rem;
  }
  </style>
